import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "swiper/css";
const villaImages = [
  "/images/Hiru/Hiru Villa's/Garden/BBC70E26-89D8-475D-A68B-CA85A81C2953.webp",
  "/images/Hiru/Hiru Villa's/Close Up/AH2I0612-copy.webp",
  "/images/Hiru/Hiru Villa's/Lobby/AH2I3255-HDR-Edit-copy.webp",
  "/images/Hiru/Hiru Villa's/Lobby/Photo-2-copy.webp",
  "/images/Hiru/Hiru Villa's/Lobby/AH2I3987-HDR-Edit-copy.webp",
  "/images/Hiru/Hiru Villa's/Lobby/AH2I3300-HDR-Edit-copy.webp",
  "/images/Hiru/Hiru Villa's/Room/AH2I3028-Edit-copy.webp",
  "/images/Hiru/Hiru Villa's/Room/AH2I3011-Edit-copy.webp",
  "/images/Hiru/Hiru Villa's/Lobby/AH2I4053-HDR-Edit-copy.webp",
  "/images/Hiru/Hiru Villa's/Lobby/AH2I3238-HDR-Edit-copy.webp"
];
const VillaImages = () => {
  return <section className="relative w-full overflow-hidden bg-white py-12 sm:py-16 lg:py-20">
    <div className="relative mx-auto max-w-[84rem] px-4 sm:px-8 lg:px-12">
      <Swiper
        modules={[Autoplay, Navigation]}
        navigation={{
          nextEl: ".villa-images-next",
          prevEl: ".villa-images-prev"
        }}
        autoplay={{ delay: 4200, disableOnInteraction: false }}
        loop
        speed={850}
        slidesPerView={1}
        className="villa-images-swiper"
      >
        {villaImages.map((image) => <SwiperSlide key={image}>
          <div className="relative aspect-[16/9] w-full overflow-hidden rounded-[20px] bg-[#f3eee7]">
            <img
              src={image}
              alt="Einrichtungen und Zimmer von Hiru Villa"
              className="object-cover transition-transform duration-700 hover:scale-[1.03]" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
          </div>
        </SwiperSlide>)}
      </Swiper>

      <button
        type="button"
        className="villa-images-prev absolute left-5 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-[#1f4d3c] shadow-lg transition hover:bg-[#F28600] hover:text-white disabled:opacity-40 sm:left-10 lg:left-14"
        aria-label="Vorheriges Bild"
        title="Vorheriges Bild"
      >
        <FiChevronLeft className="h-6 w-6" aria-hidden="true" />
      </button>
      <button
        type="button"
        className="villa-images-next absolute right-5 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-[#1f4d3c] shadow-lg transition hover:bg-[#F28600] hover:text-white disabled:opacity-40 sm:right-10 lg:right-14"
        aria-label="Nächstes Bild"
        title="Nächstes Bild"
      >
        <FiChevronRight className="h-6 w-6" aria-hidden="true" />
      </button>
    </div>
  </section>;
};
export default VillaImages;
